
import type { PropType } from 'vue'
import { defineComponent, computed } from 'vue'

export default defineComponent({
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        loadingText: {
            type: String,
            default: 'Загрузка данных...'
        },
        failed: {
            type: Boolean,
            default: false,
        },
        failedText: {
            type: String,
            default: 'При получении данных произошла ошибка'
        },
        refreshText: {
            type: String,
            default: 'Обновить'
        },
        emptyText: {
            type: String,
            default: 'Нет данных'
        },
        empty: {
            type: Boolean,
            default: false,
        },
        pagination: {
            type: Boolean,
            default: false,
        },
        page: {
            type: Number,
            default: 1
        },
        totalPages: {
            type: Number,
            default: 1
        },
        totalItems: {
            type: Number,
            default: 0
        },
        limit: {
            type: [Number, null, undefined] as PropType<number | null | undefined>,
            default: null
        },
        limits: {
            type: Array as PropType<Array<{ id: number; name: string; value: number; }>>,
            default: () => [
                { id: 1, name: '50', value: 50 },
                { id: 2, name: '20', value: 20 },
                { id: 3, name: '15', value: 15  },
                { id: 4, name: '10', value: 10 }
            ]
        },
    },
    emits: ['update:limit', 'change:limit', 'update:page', 'change:page', 'refresh'],
    setup(props, { emit }) {
        const onUpdateLimit = (limit: number) => {
            if (props.disabled || props.loading) return

            emit('update:limit', limit)
            emit('change:limit', limit)
        }

        const onUpdatePage = (page: number) => {
            if (props.disabled || props.loading) return

            emit('update:page', page)
            emit('change:page', page)
        }

        const onRefresh = () => emit('refresh')

        const itemsShown = computed(() => {
            if (props.limit) {
                if (props.totalItems === 0) {
                    return '0'
                }

                if (props.page === 1) {
                    if (props.totalItems < props.limit) {
                        return `1 – ${props.totalItems}`
                    }

                    return `1 – ${props.limit}`
                }

                return `${(props.page - 1) * props.limit} – ${props.page * props.limit}`
            }

            return null
        })

        return {
            onUpdateLimit,
            onUpdatePage,
            onRefresh,
            itemsShown
        }
    }
})
